module.exports = __webpack_public_path__ + "d5aa65bcdd76e2a9cbac63919231a8cb.svg";